import React from "react";
import { StyleTag } from "seed/helpers";


function StyleColor({ theme = {}, backgroundHeight = "100vh" }) {

	let primaryColor = theme.primaryColor ?? "#2080e5";
	let accentColor = theme.accentColor ?? "#f0b000";
	let darkColor = theme.darkColor ?? getDarkerColor(primaryColor, -30);
	let lightColor = theme.lightColor ?? getDarkerColor(primaryColor, 30);
	let accentDarkColor = theme.accentDarkColor ?? getDarkerColor(accentColor, -30)

	return <div>
		{theme.primaryColor || theme.accentColor ?
			<StyleTag content={`

		  /*
			** General components
			*/

			/* Background */

			#background-hero .path-a {
				fill: ${darkColor} !important;
			}
			#background-hero .path-b {
				fill: ${primaryColor} !important;
			}
			#background-hero .path-c {
				fill: ${accentColor} !important;
			}

			/* Buttons & Text */

			.btn.btn-primary {
				background: ${primaryColor} !important;
				border-color: ${primaryColor} !important;
			}
			.btn.btn-primary:hover {
				background: ${darkColor} !important;
			}			
			.btn.btn-outline-primary {
				border-color: ${primaryColor} !important;
				color: ${primaryColor} !important;
			}
			.btn.btn-outline-primary:hover{
				background: ${primaryColor} !important;
				color: white !important;
			}
			.btn.btn-outline-primary-white {
				border-color: ${primaryColor} !important;
				color: ${primaryColor} !important;
			}
			.btn.btn-outline-primary-white:hover {
				background: ${primaryColor} !important;
				color: white !important;
			}
			.btn.btn-accent {
				background: ${accentColor} !important;
				border-color: ${accentColor} !important;
			}
			.btn.btn-accent:hover {
				background: ${accentDarkColor} !important;
			}
			.btn.btn-outline-accent {
				border-color: ${accentColor} !important;
				color: ${getDarkerColor(accentColor, -15)} !important;
			}
			.btn.btn-outline-accent:hover{
				background: ${accentColor} !important;
				color: white !important;
			}
			.btn.btn-link {
				color: ${primaryColor} !important;
			}
			.btn.btn-link:hover{
				color: ${darkColor} !important;
			}

			.icon-primary {
				border-color: ${primaryColor} !important;
				background: ${primaryColor} !important;
			}

			.text-primary {
				color: ${primaryColor} !important;
			}
			.text-accent {
				color: ${getDarkerColor(accentColor, -15)} !important;
			}

			input[type=checkbox] {
				accent-color: ${getDarkerColor(accentColor, -15)} !important; 
			}

			.custom-control-input:checked~.custom-control-label::before{
				border-color: ${getDarkerColor(accentColor, -15)} !important;
				background-color: ${getDarkerColor(accentColor, -15)} !important; 
			}



			.navbar-nav.nav-tabs .nav-link.active {
				border-left-color: ${primaryColor} !important;
			}
			.navbar .nav-link.active {
				color: ${primaryColor} !important;
			}			

			.badge-primary {
				background: ${primaryColor} !important;
			}
			.badge-accent {
				background: ${accentColor} !important;
			}

			/* Seed components */
			.seed__loading svg {
				stroke: ${primaryColor} !important;
			}

			/* Icons */
			.process-icon-1 { fill:${primaryColor} !important;  }

			.model-icon-1 { stroke:${primaryColor} !important;}
			.model-icon-3 { fill:${primaryColor} !important;}

			.solution-icon-0 { stroke:${primaryColor}a0 !important;}
      .solution-icon-1 { fill:${primaryColor} !important;}
			.solution-icon-2 { fill:${primaryColor} !important;}
			
			/* Pagination */

			.page-item.active .page-link {
				background: ${primaryColor} !important;
				border-color: ${primaryColor} !important;
			}

			.page-item .page-link:hover {
				background: ${darkColor} !important;
				color: white !important;
			}

			/*
			** Specific views
			*/

			/* Start */

			#start-templates {
				background: #ffffff !important;
			}

			#start-activity tr th {
				background-color: ${primaryColor}20 !important;
				color: ${primaryColor} !important;
			}
			#start .navbar-vertical-content .nav-link.active i, #start .navbar-vertical-content .nav-link.active,
			#start .navbar-vertical-content .nav-link:hover i, #start .navbar-vertical-content .nav-link:hover {
				border-left-color: ${accentColor} !important;
			} 
			#start .navbar-vertical-content .nav-link.active i, #start .navbar-vertical-content .nav-link.active span, 
			#start .navbar-vertical-content .nav-link:hover i, #start .navbar-vertical-content .nav-link:hover span {
				color: ${getDarkerColor(accentColor, -15)} !important;
			}

			#start #start-content-wrapper #start-flows #start-flows-container #flows #flows-container .flow:hover .h4 {
				color: ${primaryColor} !important;
			}

			#start .template-item {
				border-left-color: ${accentColor} !important;
			}

			#background-hero-template .path-a {
				fill: ${primaryColor}20 !important;
			}
			#background-hero-template .path-b {
				fill: ${primaryColor}20 !important;
			}
			#background-hero-template .path-c {
				fill: ${darkColor}20 !important;
			}

			/* Settings */

			#settings .navbar-vertical-content .nav-link.active i, #settings .navbar-vertical-content .nav-link.active span, 
			#settings .navbar-vertical-content .nav-link:hover i, #settings .navbar-vertical-content .nav-link:hover span{
				color: ${primaryColor} !important
			}


			/* Studio */
			
			#flow-tabs a.active, #flow-tabs a:hover{
				color: ${primaryColor} !important;
				border-bottom-color: ${primaryColor} !important;
			}
			
			#workspace-title .logo-sub label {
				background: ${primaryColor} !important;
			}

			#toolbox-sidenav .btn-app:hover, #toolbox-sidenav .btn-app.active {
				color: ${primaryColor} !important;
			}

			#toolbox-sidenav .btn-app:hover i, #toolbox-sidenav .btn-app.active i {
				background-color: ${primaryColor}17 !important;
			}

			#toolbox-container #toolbox-main #toolbox-actions #toolbox-search .search-cta .search-filters.active {
				color: ${primaryColor} !important;
			}
			#toolbox-container #toolbox-actions #toolbox-tabs .tab-button.active {
				background: ${primaryColor} !important;
			}

			#toolbox-container #toolbox-actions .apps .btn-category[aria-expanded=true] .category-icon,
			#toolbox-container #toolbox-actions .apps .btn-category[aria-expanded=true] .category-title {
				color: ${primaryColor} !important;
			}

			#toolbox-container #toolbox-actions .action-element .btn-action.active {
				background: ${primaryColor} !important;
			}

			#toolbox-container #toolbox-main #toolbox-templates .tab-button.active {
				background: ${primaryColor} !important;
			}

			#toolbox-container #toolbox-actions .custom-switch .custom-control-label::before {
      	border-color: ${accentColor};
    	}

    	#toolbox-container #toolbox-actions .custom-switch .custom-control-label::after {
      	background-color: ${accentColor};
    	}

    	#toolbox-container #toolbox-actions .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
      	background-color: ${accentColor};
    	}


			#template-categories-container .tab-button.active {
				background: ${primaryColor};
			}
			

			/* Studio-board */

			.node .customize-tree-button .tree-name, .trigger .customize-tree-button .tree-name {
				background-color: ${primaryColor}20;
				border-color: ${primaryColor};
				color: ${primaryColor};				
			}

			.node .customize-tree-button .tree-name:hover, .trigger .customize-tree-button .tree-name:hover {
				background-color: ${getDarkerColor(primaryColor, -15)}3a;
			}


			/* Collection */			

			#collection-tabs .collection-tab.active {
				background: ${primaryColor} !important;
			}

			#collection-tabs .collection-tab:hover {
				background: ${darkColor} !important;
			}

			#collection-tabs .collection-tab.active span,
			#collection-tabs .collection-tab:hover span {
				color: white !important;
			}
			#table-title .edit-btn:hover{
				color: ${primaryColor} !important;
			}

			#tables #tables-body #tables-board #collection-table table td.table-record.active{
				border-color: ${accentColor} !important;
			}


			/* Presentation */

			#presentation-nav-section .tabs button.active,
			#presentation-nav-section .tabs button:hover{
				color: ${primaryColor} !important;
				border-bottom-color: ${primaryColor} !important;
			}			
			#presentation-sidenav .sidenav-item.active,
			#presentation-sidenav .sidenav-item:hover {
				color: ${getDarkerColor(accentColor, -10)} !important;
				border-left-color: ${getDarkerColor(accentColor, -10)} !important;
			}
			#presentation-header {
				background: ${primaryColor} !important;
			}
			

			
			/* Presentation chat */

			#chat .message{
				border-left-color: ${accentColor} !important;
			}

			#chat .message.user{
				background: ${primaryColor} !important;
			}

			#chat .message.suggestion{
				color: ${getDarkerColor(accentColor, -15)} !important;
				border-color: ${accentColor} !important;
			}

			#chat .message.suggestion.option{
				color: ${primaryColor} !important;
				border-color: ${primaryColor} !important;
			}

			#chat .message-wrapper:not(.user) .message-options .btn-link {
				color: ${getDarkerColor(accentColor, -15)} !important;
			}

			#chat .loading .loader:before {
				background-color:  ${primaryColor} !important;
			}

			#chat .message.inner-toast .loading-icon {
				color: ${primaryColor} !important;
			}

			#chat .input-container input:hover {
				border: 1px solid ${primaryColor}90 !important;
				box-shadow: 0 0 0.25rem ${primaryColor}a0 !important;
			}

			#chat .input-container .send,
			#chat .input-container .send:hover {
				color: ${primaryColor} !important;
			}

			
			/* Settings */
			#settings tr th {
				background-color: ${primaryColor}20 !important;
				color: ${primaryColor} !important;
			}


			/* Wizard */
			#wizard .chat-messages .message {
				border-left-color: ${primaryColor} !important;
			}
			

		` } />
			: null}

		<StyleTag content={` 
			#background-hero { 	
				display: block !important;				
			}
			#background-hero svg {
			  height: ${backgroundHeight} !important;	
			}
		` } />

	</div>

}

function getDarkerColor(color, v) {

	const normalize = (x) =>
		x > 255 ? x - (x - 255) : x;

	const getHex = (x) => {
		if (x < 0 || isNaN(x)) x = 0;
		if (x > 255) x = 255;
		x = x.toString(16);
		return x.length === 1 ? "0" + x : x;
	}

	if (color.length > 6)
		color = color.substring(1, color.length)

	var rgb = parseInt(color, 16);

	var r = Math.abs(((rgb >> 16) & 0xFF) + v);
	r = normalize(r);
	r = getHex(r);

	var g = Math.abs(((rgb >> 8) & 0xFF) + v);
	g = normalize(g);
	g = getHex(g);

	var b = Math.abs((rgb & 0xFF) + v);
	b = normalize(b);
	b = getHex(b);

	return "#" + r + g + b;

}

export default StyleColor;